import type { User } from '../types';

export const ZRMUserInfo = ({
  summary = {
    isPartialResponse: false,
  },
  isMultifamilyCustomer = false,
  isSingleFamilyEnterpriseCustomer = false,
}: User) => ({
  ...(summary.activeListingCount === undefined ? {} : { active_listing_cnt: Number(summary.activeListingCount) }),
  ...(summary.totalListingCount === undefined ? {} : { total_listing_cnt: Number(summary.totalListingCount) }),
  multi_family_customer_ind: Boolean(isMultifamilyCustomer),
  single_family_enterprise_customer_ind: Boolean(isSingleFamilyEnterpriseCustomer),
});
